<template>
  <modalForm :title="$t('automations.editTitle')" :submit-label="$t('actions.save')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-1">{{ error }}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.name') }}:</p>
      <input type="text" name="name" v-model="name" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.name.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.active') }}:</p>
      <ActiveWidget :active="active" v-on:active-changed="toggleActive" />
      <div v-for="error of v$.active.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.text') }}:</p>
      <textarea v-model="text" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm "></textarea>
      <div v-for="error of v$.text.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'
import automationModel from '@/models/automation'
import ActiveWidget from './ActiveWidget'


export default {
  mixins: [formViewMixin],
  props: ['automation'],
  name: 'AutomationEdit',
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    modalForm,
    ActiveWidget,
  },
  created() {
    this.name = this.automation.attributes.name;
    this.active = this.automation.attributes.active;
    this.text = this.automation.attributes.text;
  },
  methods: {
    async onFormValid() {
      let response;
      let automationData = automationModel.buildUpdate(this.automation.id, this.name, this.active, this.text);
      try {
        response = await automationModel.updateAutomation(this.automation.id, automationData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('automations.errorUpdating');
      }
      if (response && response.status === 204) {
          this.error = '';
          this.$emit('update-finished-event');
      }
    },
    cancel() {
      this.$emit('update-finished-event');
    },
    toggleActive() {
      this.active = !this.active;
    }
  },
  data() {
    return {
      'name': '',
      'active': '',
      'text': '',
      'error': '',
    }
  },
  validations () {
    return {
      'name': { required },
      'active': { },
      'text': { required },
    }
  }
}
</script>
